import { createAction } from 'typesafe-actions';

export const nextStep = createAction('NEXT_STEP')<null>();
export const prevStep = createAction('PREV_STEP')<null>();
export const resetSteps = createAction('RESET_STEPS')<null>();
